import { useNavigate, useParams } from 'react-router-dom';
import SITE from '../data/site';

export default function ServiceDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const { clinic, services } = SITE;
  const service = services.find(s => s.id === id);

  if (!service) return (
    <div style={{ paddingTop: 120, textAlign: 'center' }}>
      <p style={{ color: 'var(--textsoft)' }}>الخدمة غير موجودة</p>
      <button className="btn btn-gold" onClick={() => nav('/services')} style={{ marginTop: 16 }}>العودة للخدمات</button>
    </div>
  );

  return (
    <div style={{ paddingTop: 72 }}>
      <div className="page-band">
        <div className="container">
          <div className="breadcrumb">
            <a onClick={() => nav('/')}>الرئيسية</a><span>/</span>
            <a onClick={() => nav('/services')}>الخدمات</a><span>/</span>
            {service.title}
          </div>
          <h1>{service.title}</h1>
        </div>
      </div>

      <div className="container">
        <div className="svc-layout">

          {/* CONTENT */}
          <div className="svc-content">
            <div className="svc-detail-img" >
              {service.img
                ? <img style={{objectFit : 'contain'}} src={service.img} alt={service.title} />
                : <div className="svc-detail-img-ph">
                    <span className="ph-icon">{service.icon}</span>
                    <span className="ph-txt">صورة {service.title}</span>
                  </div>
              }
            </div>

            {service.content.map((block, i) => (
              <div key={i}>
                <h2>{block.h}</h2>
                {block.p && (
                  block.highlight
                    ? <div className="highlight-box">{block.p}</div>
                    : <p>{block.p}</p>
                )}
                {block.ul && (
                  <ul>
                    {block.ul.map((item, j) => <li key={j}>{item}</li>)}
                  </ul>
                )}
              </div>
            ))}
          </div>

          {/* SIDEBAR */}
          <div className="svc-sidebar">
            <div className="sidebar-nav">
              <div className="sidebar-nav-title">✦ خدماتنا</div>
              {services.map(s => (
                <span
                  key={s.id}
                  className={`sidebar-link${s.id === id ? ' active' : ''}`}
                  onClick={() => nav(`/services/${s.id}`)}
                >
                  {s.icon} {s.title}
                </span>
              ))}
            </div>
            <div className="sidebar-cta">
              <h4>احجز موعدك</h4>
              <p>تواصل معنا عبر واتساب أو هاتف</p>
              <a className="btn btn-wa" href={clinic.whatsapp} target="_blank" rel="noreferrer">💬 واتساب</a>
              <a className="btn btn-dark" href={`tel:${clinic.phone}`}>📞 {clinic.phone}</a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
